"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNSUBSCRIBED = exports.SUBSCRIBED = exports.OPTED_IN = void 0;
var UNSUBSCRIBED = exports.UNSUBSCRIBED = 'unsubscribed';
var SUBSCRIBED = exports.SUBSCRIBED = 'subscribed';
var OPTED_IN = exports.OPTED_IN = 'opted_in';